export default __webpack_public_path__ + "static/center-ru-294838b13d55a6bddb483ee509bf463d.webp";